import {connect} from 'react-redux';

import {getIsUserGlobalAdmin} from '../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getCompanyPreferences} from '../../../../store/data/company/companySelectors';
import {getFlatGlobalAdmins, getUserId} from '../../../../store/data/teammates/teammatesSelectors';
import {AbuserFlagBanner} from './abuserFlagBanner';

/*
 * Redux.
 */

const getIsFlagged = createSelector([getCompanyPreferences], (pref) => pref.isChannelAbuser);
const getOtherAdmins = createSelector([getFlatGlobalAdmins, getUserId], (admins, userId) =>
  admins.filter((a) => a.id !== userId),
);

const mapStateToProps = makeMapStateToProps()(() => ({
  userId: getUserId,
  isFlagged: getIsFlagged,
  isAdmin: getIsUserGlobalAdmin,
  otherAdmins: getOtherAdmins,
}));

export const AbuserFlagBannerContainer = connect(mapStateToProps)(AbuserFlagBanner);
